module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Meus Projetos de Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaMeusProjetosPesquisa,
      "search": _vm.search,
      "no-data-text": 'Você não participa de nenhum projeto de pesquisa',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "library_books",
            "color": "primary",
            "tooltip": "Visualizar cadastro do projeto"
          },
          on: {
            "click": function($event) {
              return _vm.toAbrirCadastroProjetoPesquisa(props.item.id)
            }
          }
        })]
      }
    }, {
      key: "item.numRegistro",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.numRegistro === null || props.item.numRegistro === '' ? '-' : props.item.numRegistro))]
      }
    }, {
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaMeusProjetosPesquisa.length) + " " + _vm._s(_vm.listaMeusProjetosPesquisa.length > 1 ? 'projetos' : 'projeto') + "\n          ")]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f0268c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/meus-projetos-pesquisa.vue
// module id = 796
// module chunks = 0